import React from 'react';

/**
 * Floating pill-shaped footer for the Funeral Professional portal.
 *
 * Uses its own visual system (frosted glass, soft shadow, rounded
 * capsule) instead of a full-width bar so the portal reads as a
 * commercial product and not a public website. No marketing email
 * addresses on the page per product direction.
 */
const FdFooter = () => {
  const year = new Date().getFullYear();
  return (
    <div className="fd-footer-wrap" role="contentinfo">
      <footer className="fd-footer-pill">
        <div className="fd-footer-brand-mini" aria-hidden="true">
          <span className="fd-footer-dot-mark"></span>
          <span>ObitAuthor</span>
        </div>

        <nav className="fd-footer-nav" aria-label="Portal footer">
          <a className="fd-footer-link" href="/funeral-directors">Program</a>
          <a className="fd-footer-link" href="/funeral-directors#fd-faq">FAQ</a>
          <a className="fd-footer-link" href="/funeral-directors/terms">Terms</a>
          <a className="fd-footer-link" href="/funeral-directors/privacy">Privacy</a>
        </nav>

        <span className="fd-footer-copy">&copy; {year} ObitAuthor</span>
      </footer>
    </div>
  );
};

export default FdFooter;
